import ConsumptionQuery from './ConsmptionQuery';
import ConsumptionDetailContainer from './ConsumptionDetailContainer';

const creditsRoutes = [
  { path: '/accounts/:aid/consumption/', component: ConsumptionQuery, exact: true },
  { path: '/accounts/:aid/consumption/:consumptionId', component: ConsumptionDetailContainer },
];

export default creditsRoutes;
